import { render } from "./BookingSubmissionBanner.vue?vue&type=template&id=36569d73"
import script from "./BookingSubmissionBanner.vue?vue&type=script&lang=js"
export * from "./BookingSubmissionBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__